<ng-container *ngIf="file$ | async as file">
    <div class="column is-1 document-icon">
        <isav-file-icon [mimeType]="file.mimeType"></isav-file-icon>
    </div>
    <div class="column is-11 document-name">
        <a [href]="downloadIri" download target="_blank">{{ file.name }}</a>
    </div>
</ng-container>
